<script setup>
defineProps({
	message: {
		type: Object,
		required: true
	}
});
</script>

<template>
  <div class="message-wrapper user">
    <div class="message-bubble user">
      <div class="message-content">
        {{ message.content }}
      </div>
    </div>
  </div>
</template>
